import { ArticleModel } from "@/types/api"
import { baseApi } from "./baseApi"

const accessoriesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAccessories: builder.query<ArticleModel[], void>({
      query: () => {
        return `Accessories`
      },
      providesTags: (result, error, arg) => [{ type: 'Search', id: 'LIST' }],
      keepUnusedDataFor: 300,
    }),
  }),
})

export const { useGetAccessoriesQuery } = accessoriesApi